import { v2Api } from './v2Client';

/** SmartPadel (éclairage des terrains) — voir squash_manger_api_v2/docs/SMARTPADEL.md. Administrateur (rôle 1). */

/** Connexion avec les identifiants enregistrés dans Configuration → SmartPadel.
 * → { message, account_name, account_id, user_id, expires_at, installations, installations_error }. */
export async function testSmartPadelConnection() {
  const { data } = await v2Api.post('/SmartPadel/test_connection');
  return data;
}

/** État de l'éclairage (installations, terrains, programmations, historique ~7 j, codes d'accès) — cache API 10 s,
 * `refresh` le contourne. */
export async function fetchSmartPadelOverview({ refresh = false } = {}) {
  const { data } = await v2Api.get('/SmartPadel/overview', { params: refresh ? { refresh: true } : undefined });
  return data;
}

/** Bascule l'interrupteur `target` (« light » = Éclairage, « manual » = Manuel) d'un terrain, comme un clic dans
 * SmartPadel. `expectedOn` : état affiché (409 s'il a changé entre-temps). Retourne l'état relu (même forme que
 * fetchSmartPadelOverview). */
export async function toggleSmartPadel({ sectionId, target, expectedOn }) {
  const { data } = await v2Api.post('/SmartPadel/toggle', { section_id: sectionId, target, expected_on: expectedOn });
  return data;
}

/** Allumage automatique par les réservations : mode, réglages, décision par terrain associé, journal récent. */
export async function fetchSmartPadelAutomation() {
  const { data } = await v2Api.get('/SmartPadel/automation');
  return data;
}

/** Lance un cycle tout de suite (rien en mode « off », journal seul en « observe ») ; renvoie l'état. */
export async function runSmartPadelAutomation() {
  const { data } = await v2Api.post('/SmartPadel/automation/run');
  return data;
}

/** Terrains du club, leur association SmartPadel et les terrains SmartPadel associables. */
export async function fetchSmartPadelTerrainLinks() {
  const { data } = await v2Api.get('/SmartPadel/terrain_links');
  return data;
}

/** Associe un terrain du club à un terrain SmartPadel (`sectionId` null = dissocier) ; renvoie les associations. */
export async function setSmartPadelTerrainLink({ terrainId, sectionId }) {
  const { data } = await v2Api.put('/SmartPadel/terrain_link', { terrain_id: terrainId, section_id: sectionId || null });
  return data;
}
